import { CdkDrag } from '@angular/cdk/drag-drop';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { AgGridService } from '@approot/services';
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  GridReadyEvent,
  SideBarDef
} from 'ag-grid-community';
import { map, Subscription } from 'rxjs';
import { WindowIndexService } from '../rfq-container/window-index.service';
import { RfqTimelineService } from '../services/rfq-timeline.service';

const WIN_POSITION_MIN_X = 8;
const WIN_POSITION_MIN_Y = 36;
const WIN_POSITION_RIGHT_MIN = 100;

@Component({
  selector: 'app-rfq-timeline',
  templateUrl: './rfq-timeline.component.html',
  styleUrls: ['./rfq-timeline.component.scss']
})
export class RfqTimelineComponent implements OnInit, AfterViewInit, OnDestroy {
  public dragging = false;
  public gridApi: GridApi;
  public columnApi: ColumnApi;
  public gridOptions: GridOptions = {};
  public readonly defaultColDef: ColDef = {
    sortable: true,
    enableRowGroup: true,
    resizable: true,
    filter: true
  };
  public sideBarDef: SideBarDef;
  @ViewChild(CdkDrag) public dragEl: CdkDrag;
  public gridOptionsSubscription: Subscription;

  constructor(
    private rfqTimelineService: RfqTimelineService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private winIdx: WindowIndexService,
    private agGridService: AgGridService
  ) {}

  public ngOnInit(): void {
    this.sideBarDef = this.agGridService.sideBarDef;
    this.gridOptionsSubscription = this.rfqTimelineService.agGridOptions$
      .pipe(
        map(gridOptions => {
          const columns = (gridOptions.columnDefs as ColDef[]).map(columnDef =>
            this.agGridService.headers.find(
              header => header.field === columnDef.field
            )
          );

          gridOptions.columnDefs = columns as ColDef[];
          if (!this.gridApi) {
            this.gridOptions = gridOptions;
          } else {
            this.gridApi.setColumnDefs(gridOptions.columnDefs);
            this.gridApi.setRowData(gridOptions.rowData);
            this.updateZIndex();
          }
        })
      )
      .subscribe();
  }

  public ngAfterViewInit(): void {
    this.updateZIndex();
  }

  public ngOnDestroy(): void {
    this.gridOptionsSubscription?.unsubscribe();
  }

  public updateZIndex(): void {
    this.winIdx.setWindowIndex(
      this.elementRef.nativeElement.querySelector('.rfq-drag'),
      this.renderer
    );
  }

  public onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  public firstDataRendered(): void {
    this.resizeColumns();
  }

  public closeWindow(): void {
    this.rfqTimelineService.closeWindow();
  }

  public dragStart(): void {
    this.dragging = true;
  }

  public dragEnd(): void {
    this.dragging = false;
    const el = (this.elementRef.nativeElement as HTMLElement).querySelector(
      '.rfq-drag'
    );
    const rect = el.getBoundingClientRect();

    let { x, y } = this.dragEl.getFreeDragPosition();

    if (rect.x < WIN_POSITION_MIN_X) {
      x += WIN_POSITION_MIN_X - rect.x;
    }
    if (rect.y < WIN_POSITION_MIN_Y) {
      y += WIN_POSITION_MIN_Y - rect.y;
    }
    if (rect.x > window.innerWidth - WIN_POSITION_RIGHT_MIN) {
      x -= rect.x - (window.innerWidth - WIN_POSITION_RIGHT_MIN);
    }
    this.dragEl.setFreeDragPosition({ x, y });
  }

  private resizeColumns(skipHeader = false): void {
    const colIds = this.columnApi.getColumns().map(column => column.getColId());
    this.columnApi.autoSizeColumns(colIds, skipHeader);
  }
}
